import { Box, BoxProps } from '@mui/material'
import { FlexibleBox } from '../../FlexibleBox'
import {
  PlanPurchaseExperienceMainContentMaxWidth,
  PlanPurchaseExperiencePromoContentFullWidth
} from '@app/common/src/components/PlanPurchaseExperience/constants'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { css } from '@emotion/react'
import chroma from 'chroma-js'
import styled from '@emotion/styled'
import theme from '../../../theme'

export const containerStyles = css`
  padding-left: 34px;
  padding-right: 34px;
`

export const _Container = styled(Box)`
  ${containerStyles};
`
export const _Divider = styled('hr')`
  margin: 40px 34px;
  border: 0;
  height: 1px;
  background-color: ${theme.colors.secondary.border};
`

export const _TextDivider = styled(Box)`
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin: 0px 10px;

  &&::before,
  &&::after {
    content: '';
    flex-grow: 1;
    background-color: ${theme.colors.secondary.border};
    height: 1px;
    font-size: 0px;
    line-height: 0px;
    margin: 40px 24px;
  }
`

export const _SubHeadingText = styled(Text)`
  && {
    ${containerStyles};
    margin-top: 24px;
  }
`

function isColor(value: string | undefined): boolean {
  return chroma.valid(value)
}

export const _PromoContentBox = styled(Box)`
  display: flex;
  flex-flow: column nowrap;
  flex: 0 0 auto;
  order: 1;
`

export const _PromoBox = styled(
  (props: BoxProps & { backgroundImageUrl?: string; isTextVersion?: boolean }) => {
    const {
      backgroundImageUrl: _backgroundImageUrl,
      isTextVersion: _isTextVersion,
      ...boxProps
    } = props
    return <Box {...boxProps} />
  }
)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  flex: 1 0 auto;
  height: ${props => (props.isTextVersion ? 'auto' : '153px')};
  background-color: ${props => {
    if (isColor(props.backgroundImageUrl)) {
      return props.backgroundImageUrl
    }
  }};
  background-image: ${props => {
    if (isColor(props.backgroundImageUrl)) {
      return undefined
    }
    return props.backgroundImageUrl
      ? `url('${props.backgroundImageUrl}')`
      : `url('/images/pages/upgrade/promo-bg.svg')`
  }};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
`

export const _PromoHeaderText = styled(Text)`
  text-align: center;
`
export const _PromoCouponBox = styled(Box)(() => {
  return {
    margin: 'unset auto',
    textAlign: 'center'
  }
})

export const _PromoHeaderBox = styled(Box)`
  ${containerStyles};
  display: none;
`

export const _PromoHeaderBoxSmall = styled(Box)`
  ${containerStyles};
  display: block;
  padding-top: 48px;
  padding-bottom: 16px;
`

export const _PromoImageBox = styled(Box)`
  display: none;
  margin: 0 auto;
  margin-top: 49px;
  max-width: 100%;
`

export const _PromoImageBoxSmall = styled(Box)`
  width: 226px;
  height: 137px;
  position: relative;
  margin: 0 auto;
`

export const _PromoFooterBox = styled(Box)`
  ${containerStyles};
  display: none;
  margin-top: 32px;
  width: 100%;
`
export const _MainContentBox = styled(Box)`
  display: flex;
  flex-flow: column nowrap;
  order: 2;
  flex: 0 1 auto;
`

export const _RootBoxPlanPurchaseExperience = styled(FlexibleBox)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  &.wide {
    flex-flow: row nowrap;
    justify-content: center;

    ${_MainContentBox} {
      order: 1;
      width: ${PlanPurchaseExperienceMainContentMaxWidth}px;
      max-width: 100%;
    }

    ${_PromoContentBox} {
      order: 2;
      width: ${PlanPurchaseExperiencePromoContentFullWidth}px;
    }

    ${_PromoImageBoxSmall} {
      display: none;
    }

    ${_PromoBox} {
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-start;
      position: relative;
      padding: 32px 0;
      width: ${PlanPurchaseExperiencePromoContentFullWidth}px;
      height: auto;
    }

    ${_PromoHeaderBox} {
      display: block;
    }

    ${_PromoHeaderBoxSmall} {
      display: none;
    }

    ${_PromoImageBox} {
      display: block;
    }

    ${_PromoFooterBox} {
      display: block;
    }
  }
`

export const _BodyBox = styled(Box)`
  flex: 1 0 auto;
  position: relative;
  z-index: 0;
`
